const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export const api = {
  // Public endpoints
  async createLead(data) {
    const response = await fetch(`${API_URL}/api/leads`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create lead');
    return response.json();
  },

  async getAgentPublic(slug) {
    const response = await fetch(`${API_URL}/api/agents/${slug}`);
    if (!response.ok) throw new Error('Agent not found');
    return response.json();
  },

  async getDefaultContent() {
    const response = await fetch(`${API_URL}/api/default-content`);
    if (!response.ok) throw new Error('Failed to load content');
    return response.json();
  },

  // Auth endpoints
  async login(email, password) {
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }
    return response.json();
  },

  // Leads
  async getLeads(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const response = await fetch(`${API_URL}/api/bo/leads?${queryString}`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch leads');
    return response.json();
  },

  async getLead(id) {
    const response = await fetch(`${API_URL}/api/bo/leads/${id}`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch lead');
    return response.json();
  },

  async updateLead(id, data) {
    const response = await fetch(`${API_URL}/api/bo/leads/${id}`, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to update lead');
    return response.json();
  },

  async getStats() {
    const response = await fetch(`${API_URL}/api/bo/stats`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch stats');
    return response.json();
  },

  // Page content
  async updatePageContent(agent_slug, content) {
    const response = await fetch(`${API_URL}/api/bo/page-content`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ agent_slug, content })
    });
    if (!response.ok) throw new Error('Failed to update content');
    return response.json();
  },

  // SEO
  async updateSEO(agent_slug, seo) {
    const response = await fetch(`${API_URL}/api/bo/seo`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ agent_slug, seo })
    });
    if (!response.ok) throw new Error('Failed to update SEO');
    return response.json();
  },

  // Tracking
  async updateTracking(agent_slug, tracking) {
    const response = await fetch(`${API_URL}/api/bo/tracking`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ agent_slug, tracking })
    });
    if (!response.ok) throw new Error('Failed to update tracking');
    return response.json();
  },

  // Branding (white-label)
  async updateBranding(agent_slug, branding) {
    const response = await fetch(`${API_URL}/api/bo/branding`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ agent_slug, branding })
    });
    if (!response.ok) throw new Error('Failed to update branding');
    return response.json();
  },

  async getBranding(agent_slug) {
    const response = await fetch(`${API_URL}/api/bo/branding/${agent_slug}`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch branding');
    return response.json();
  },

  // Agents (admin only)
  async createAgent(data) {
    const response = await fetch(`${API_URL}/api/bo/agents`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to create agent');
    }
    return response.json();
  },

  async listAgents() {
    const response = await fetch(`${API_URL}/api/bo/agents`, {
      headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Failed to fetch agents');
    return response.json();
  }
};
